/*
 * Die Anwendertexte der Benachrichtigungs-Einstellungen, die eine Rückfrage stellen (Hausregel „Texte in Properties“:
 * Schlüssel englisch, Werte deutsch). Entfernen eines Geräts ist ein Löschweg und fragt deshalb vorher (Hausregel
 * „Bestätigung vor Datenänderung“, 19.10.2026) — klein und gestapelt wie „Anlage entfernen?“, nicht rot (Rot-Regel: `useBestaetigung`): Auf
 * dem Gerät selbst lässt sich Push jederzeit wieder einschalten.
 */
export const NOTIFICATION_TEXT = {
  removeDeviceTitle: (name: string): string => `Gerät ${name} entfernen?`,
  removeDeviceText: "Das Gerät bekommt danach keine Push-Mitteilungen mehr. Auf dem Gerät selbst lässt sich Push "
    + "jederzeit wieder einschalten.",
  removeDevice: "Entfernen",
};
